var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdrtanlg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.608,7.112a8.911,8.911,0,0,0-2.317-.667V5.591l1.171-.553a.307.307,0,0,0,.183-.263.3.3,0,0,0-.162-.274l-1.072-.6a.373.373,0,0,0-.347-.007.305.305,0,0,0-.175.27V6.381a22.084,22.084,0,0,0-3.051-.216V5.228L9.177,4.6a.353.353,0,0,0,.21-.3A.346.346,0,0,0,9.2,3.982L7.975,3.3a.429.429,0,0,0-.4-.008.351.351,0,0,0-.2.309V6.167a21.3,21.3,0,0,0-3.109.256V5.591L5.44,5.038a.307.307,0,0,0,.183-.263A.3.3,0,0,0,5.461,4.5L4.389,3.9A.373.373,0,0,0,4.042,3.9a.305.305,0,0,0-.175.27V6.494a8.37,8.37,0,0,0-2.046.618.327.327,0,0,0-.2.376H1.619l.01.021.25,2.019a.56.56,0,0,0,.207.368l.154.121a.563.563,0,0,1,.2.341l.19,1.1a.531.531,0,0,0,.073.2c.162.258.72.877,2.466,1.2a.408.408,0,0,0,.474-.4V11.223a.409.409,0,0,1,.408-.409H9.375a.408.408,0,0,1,.408.409v1.221a.41.41,0,0,0,.478.4c2.24-.412,2.523-1.315,2.523-1.315h.007l.2-1.175a.563.563,0,0,1,.2-.341l.154-.121a.56.56,0,0,0,.207-.368l.252-2.04A.368.368,0,0,0,13.608,7.112ZM7.715,9a13.684,13.684,0,0,1-4.886-.661c-.478-.415.548-.685.548-.685a14.967,14.967,0,0,1,4.338-.565,15.011,15.011,0,0,1,4.338.564c.666.175.614.526.552.683A13.625,13.625,0,0,1,7.715,9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdrtanlg);
export default __webpack_public_path__ + "static/media/IDRÆTANLÆG.076e2003fd99d138da504a9b117d90f7.svg";
export { ForwardRef as ReactComponent };